function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#282828;}.a{fill:#fff;}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "b",
  cx: 27.49,
  cy: 27.49,
  r: 27.49
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M34.13,27.49a6.65,6.65,0,0,0-3.69-5.94v3.26l3.61,3.61A5.46,5.46,0,0,0,34.13,27.49Zm3.68,0a10.13,10.13,0,0,1-.79,3.9l2.22,2.22a13,13,0,0,0,1.52-6.12A13.26,13.26,0,0,0,30.44,14.57v3A10.33,10.33,0,0,1,37.81,27.49ZM16.1,14.23,14.23,16.1l7,7h-7v8.85h5.89l7.37,7.37V29.37l6.27,6.26a10.14,10.14,0,0,1-3.32,1.74v3a13.22,13.22,0,0,0,5.44-2.67l3,3,1.87-1.87L27.49,25.62ZM27.49,15.7l-3.08,3.08,3.08,3.08Z"
});

const SvgMute = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 54.99 54.99",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMute, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mute.7860bee6.svg";
export { ForwardRef as ReactComponent };